<div class="container-tabs">
  <div class="tab" *ngFor="let tab of tabs" [ngClass]="{ 
    active: tabActive === tab, 
    disabled: disabledTabs.includes(tab),
    'item-bloqueado-plano-basico': planoBasicoCtrl.checkSeItemEstaBloqueadoEmPlanoBasico('tabs', tab)
  }" (click)="selectTab(tab, $event)">
    <p>{{ tab }}</p>
  </div>
</div>
